import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { useQuery } from '@apollo/react-hooks';
import { GET_PROJECTS } from './queries';
import { IProjects } from '../../helper/Types';

import { useQueryParams, StringParam } from 'use-query-params';
import * as queryString from 'query-string';

import { toast } from "react-toastify";
import Select, { OptionTypeBase, ValueType } from 'react-select';
import { VALoading, VALazyImage } from '../../components/';
import { Element, scroller } from 'react-scroll';


import { PROJECTS_CATEGORY, getCategoryTypeTitle, getCategoryProgramTitle, getListTypeByProjects, setListTypeByProjects } from '../../helper/constants';

function ProjectsContainer() {
    const history = useHistory();
    const params:any = useParams();

    const [query, setQuery] = useQueryParams({
        year: StringParam,
        type: StringParam,
        program: StringParam,
        lastIndex: StringParam
    });

    const [filter, setFilter] = useState<any>({
        category: params.type,
        year: { value: query.year !== undefined ? query.year : 'all', label: query.year !== undefined ? query.year : 'Year' },
        // type: { value: query.type !== undefined ? query.type : 'all', label: query.type !== undefined ? query.type : 'Type' },
        type: {
            value: params.type !== undefined ? params.type : 'all',
            label: params.type !== undefined ? params.type : 'Type'
        },
        program: { value: query.program !== undefined ? query.program : 'all', label: query.program !== undefined ? query.program : 'Program' }
    });

    const [listType, setListType] = useState<string | 'thumbnail' | 'list'>(getListTypeByProjects());
    const [categoryTypeOptions, setCategoryTypeOptions] = useState<any>([]);
    const [yearOptions, setYearOptions] = useState<any>();
    const [categoryProgramOptions, setCategoryProgramOptions] = useState<any>([]);
    

    const handleListType = (event: React.ChangeEvent<HTMLInputElement>) => {
        setListTypeByProjects(event.target.value);
        setListType(event.target.value);
    }

    const handleChangeYear = (value: ValueType<OptionTypeBase, false>) => {
        setFilter((_filter:any) => ({
            ..._filter,
            year: value
        }));

        const queryValue:any = value;
        setQuery({
            year: queryValue.value
        });
    }

    const handleChangeType = (value: ValueType<OptionTypeBase, false>) => {
        const selectedValue:any = value;

        if( selectedValue.value === 'all' ) {
            setCategoryProgramOptions([]);
            setFilter((_filter:any) => ({
                ..._filter,
                type: value,
                program: { value: 'all', label: 'All' }
            }));
        } else {
            const _categoryType:any = PROJECTS_CATEGORY.find((_type:any) => _type.uid === selectedValue.value);
            let _categoryOptionProgram = [
                { value: 'all', label: 'All' }
            ]
            _categoryOptionProgram = _categoryOptionProgram.concat(_categoryType.program.map((_item:any, _index:number) => {
                return({
                    value: _item.uid,
                    label: _item.title
                })
            }));
    
            setCategoryProgramOptions(_categoryOptionProgram);

            setFilter((_filter:any) => ({
                ..._filter,
                type: value,
                program: { value: 'all', label: 'All' }
            }));
        }

        setQuery({
            type: selectedValue.value,
            program: "all"
        });    
    }

    const handleChangeProgram = (value: ValueType<OptionTypeBase, false>) => {
        const selectedValue:any = value;

        setFilter((_filter:any) => ({
            ..._filter,
            program: value
        }));

        setQuery({
            program: selectedValue.value
        });    
    }

    const getlabelByValue = (option:any) => {
        if( option.value === 'all' ) {
            return 'All';
        }
        return option.label;
    }

    const loadData = useQuery<IProjects>(GET_PROJECTS, {
        variables: {
            year: filter.year.value,
            type: params.type,
            program: filter.program.value,
        },
        fetchPolicy: "cache-first"
    });

    if( loadData.error ) {
        toast.error(loadData.error.message);
    }

    useEffect(() => {
        console.log("params type : " + params.type);

        let _type = {
            value: String(params.type).toLowerCase(),
            label: String(params.type).charAt(0).toUpperCase() + String(params.type).slice(1)
        };
        if( params.type === "all" ) {
            _type = { value: query.type !== undefined ? query.type : 'all', label: query.type !== undefined ? query.type : 'Type' }
            setCategoryProgramOptions({ value: 'all', label: 'All' })
        } else {
            const _categoryType:any = PROJECTS_CATEGORY.find((_type:any) => _type.uid === params.type);
            let _categoryOptionProgram = [
                { value: 'all', label: 'All' }
            ]
            _categoryOptionProgram = _categoryOptionProgram.concat(_categoryType.program.map((_item:any, _index:number) => {
                return({
                    value: _item.uid,
                    label: _item.title
                })
            }));
            console.log(_categoryOptionProgram);
            setCategoryProgramOptions(_categoryOptionProgram);
        }

        setFilter((_filter:any) => ({
            ..._filter,
            type: _type,
            program: { value: 'all', label: 'All' }
        }));


    }, [params.type]);


    // mount
    useEffect(() => {
        console.log("mount");

        const now = new Date();
        let _yearsOption = [
            { value: 'all', label: 'All' }
        ]

        for( let i=0; i<=now.getFullYear() - 2000; i++ ) {
            const _year:string = String(now.getFullYear() - i);
            _yearsOption.push({
                value: _year,
                label: _year
            });
        }
        setYearOptions(_yearsOption);

        // let _categoryOptionType = [
        //     { value: 'all', label: 'All' }
        // ]
        // _categoryOptionType = _categoryOptionType.concat(PROJECTS_CATEGORY.map((_item:any, _index:number) => {
        //     return({
        //         value: _item.uid,
        //         label: _item.title
        //     })
        // }));
        // setCategoryTypeOptions(_categoryOptionType);
        

        let scrollOption:any = {
            duration: 500,
            delay: 0,
            smooth: true,
            offset: -86
        }
        if( listType === "list" ) {
            scrollOption = {
                ...scrollOption,
                offset: 0,
                containerId: 'projects-scroll-container'
            }
        }

        const target = `uid-${query.lastIndex}`;
        scroller.scrollTo(target, scrollOption);
    }, []);


    return(
        <article className={`layout-contents-container page-projects ${listType === 'list' ? 'stretch' : ''}`}>
            <h1 className="hidden">프로젝트 목록</h1>

            {/* 프로젝트 필터 선택 상태 */}
            <div className="projects-state">
                <p className="filters">Project / Year: {getlabelByValue(filter.year)} / Type: {getlabelByValue(filter.type)} / Program: {getlabelByValue(filter.program)}</p>
                
                <div className="segmented-control">
                    <input type="radio" id="listType01" name="listType" className="control" value="list" checked={listType === 'list'} onChange={handleListType} />
                    <label htmlFor="listType01">List</label>

                    <input type="radio" id="listType02" name="listType" className="control" value="thumbnail" checked={listType === 'thumbnail'} onChange={handleListType} />
                    <label htmlFor="listType02">Thumbnails</label>
                </div>
            </div>

            { listType === 'thumbnail' ? (
                <ul className="list-projects">
                    { loadData.loading && <li><VALoading /></li> }
                    { loadData.error && <li>에러가 발생했습니다.<br/>{loadData.error.message}</li> }

                    { loadData.data?.projects.length === 0 && <li>등록된 내용이 없습니다.</li> }
                    { loadData.data?.projects.map((_project:any, _index:number) => {

                        const handleBeforeClick = (e:React.MouseEvent<HTMLSpanElement, MouseEvent>, _index:string, url:string) => {
                            setQuery({
                                lastIndex: _index
                            })
                            
                            history.push(url);
                        }

                        return(
                            <li key={_index}>
                                <Element name={`uid-${_index}`}>
                                <button type="button" onClick={(e) => { handleBeforeClick(e, _index.toString(), `/project/${_project.uid}`); }} className="project-item">
                                    <div className="thumbs" style={{ backgroundImage: `url('${_project.project.thumbnail[0].url}')` }}>
                                        <div className="inner"><VALazyImage src={_project.project.thumbnail[0].url} alt="" /></div>
                                    </div>
                                    <p className="title">{_project.title}</p>
                                </button>
                                </Element>
                            </li>
                        )
                    }) }
                </ul>
            ) : (
                <table className="tbl-default-v2">
                    <caption>프로젝트 목록</caption>
                    <thead>
                        <tr>
                            <th className="column-index">No</th>
                            <th className="p-title">Project</th>
                            <th className="p-year">
                                <Select options={yearOptions}
                                    value={filter.year}
                                    onChange={handleChangeYear}
                                    isSearchable={false}
                                    placeholder="Year"
                                    className="THSelect"
                                    classNamePrefix="VA"
                                />
                            </th>
                            <th className="p-type">
                                { params.type === "all" ? "Type" : params.type }
                                {/* <Select options={categoryTypeOptions}
                                    value={filter.type}
                                    onChange={handleChangeType}
                                    isSearchable={false}
                                    placeholder="Type"
                                    className="THSelect"
                                    classNamePrefix="VA"
                                    isDisabled={params.type !== "all"}
                                /> */}
                            </th>
                            <th className="p-program">
                                { params.type === "all" ? "Program" : (
                                    <Select options={categoryProgramOptions}
                                        value={filter.program}
                                        onChange={handleChangeProgram}
                                        isSearchable={false}
                                        placeholder="Program"
                                        className="THSelect"
                                        classNamePrefix="VA"
                                    />
                                )}
                            </th>
                            <th className="p-location">Location</th>
                        </tr>
                    </thead>
                    <tbody id="projects-scroll-container">
                        { loadData.loading && <tr><td colSpan={6} className="none"><VALoading /></td></tr> }
                        { loadData.error && <tr><td colSpan={6} className="none">에러가 발생했습니다.<br/>{loadData.error.message}</td></tr> }

                        { loadData.data?.projects.length === 0 && <tr><td colSpan={6} className="none">등록된 내용이 없습니다.</td></tr> }
                        { loadData.data?.projects.map((_project:any, _index:number) => {
                            const total:any = loadData.data?.projects.length;

                            const stringified = queryString.stringify({
                                ...query
                            });

                            const handleBeforeClick = (e:React.MouseEvent<HTMLSpanElement, MouseEvent>, _index:string, url:string) => {
                                setQuery({
                                    lastIndex: _index
                                })
                                
                                history.push(url);
                            }
    
                            
                            return(
                                <Element key={_index} name={`uid-${_index}`}>
                                <tr onClick={(e) => { handleBeforeClick(e, _index.toString(), `/project/${_project.uid}?${stringified}`); }}>
                                    <td className="column-index">{total - _index}</td>
                                    <th className="p-title link">
                                        {/* <Link to={`/project/${_project.uid}?${stringified}`}>{_project.title}</Link> */}
                                        <span>{_project.title}</span>
                                    </th>
                                    <td className="p-year">{_project.year}</td>
                                    <td className="p-type">{getCategoryTypeTitle(_project.project.type)}</td>
                                    <td className="p-program">{getCategoryProgramTitle(_project.project.type, _project.project.program)}</td>
                                    <td className="p-location">{_project.project.location}</td>
                                </tr>
                                </Element>
                            )
                        }) }
                    </tbody>
                </table>
            )}

        </article>
    );
}

export default ProjectsContainer;
